import React from 'react';

export default function SuccessfulSubmission() {
    return <div>SuccessfulSubmission</div>;
}
